import { i18n } from "@lingui/core";
import { z } from "zod";
import { fallbackMessage } from "./zodMessages";

// zod's built-in messages are English only. Answer every issue that no schema
// message answers with a translated one in the active locale (#2235); a check's
// own message or a schema-level `error` still wins over this fallback (#2151).
// A missing value keeps the zod 3 text "Required", now translated.
z.config({
  customError: (issue) => fallbackMessage(i18n, issue),
});
